export { ContentType, AssetType, EventStage, VideoInitiate, VideoCuration, NielsenTrackingType } from './addon-playout.enums';
/**
 * @public
 */ // Provides the Nielsen subbrand which indicates the originator of the video asset.
// This TMS ID allows Nielsen and NBCU to group by episodes and more importantly to associate the content with a broader set of Gracenote metadata.
// From ATOM
// From ATOM, e.g. Action and Adventure, Animation, Celebrity and Gossip, College Football, College Sports
// Video state, e.g. `SVOD`, `AVOD`, `Free Trial`
// Global title management ID
// Sponsor name if there is a single sponsor of the video campaign for curated rails (ie Verizon, McDonald's, etc)
// From ATOM, represents the network that is playing that content
// From ATOM, represents the studio that created the content
// Sport category (Sport only)
// Sports league (Sport only)
// Special event type, e.g. `Olympics`, `WWE`
// Date when video was first published
// Date when video first aired
// Boolean of the entitlement, Free = false, Entitled = true
// https://wiki.inbcu.com/pages/viewpage.action?spaceKey=Playback&title=Adobe+Analytics
/** Used by AGF Nielsen Reporting Addon */ /** Used by AGF Nielsen Reporting Addon */ /** Used by AGF Nielsen Reporting Addon */ /** Used by AGF Nielsen Reporting Addon */ /**
     * The start time of the current programme, as measured in seconds since 1 Jan 1970.
     * Retrieve from the Atlantis Schedule API, as parameter `schedule.events[].st`.
     * See https://wiki.at.sky/pages/viewpage.action?spaceKey=OCD&title=AS+Schedule+API+-+Atlantis
     * Required for Linear, not required for SLE.
     */ export function checkIsVodMetadata(metadata) {
    return 'uuid' in metadata;
}
export function checkIsLiveMetadata(metadata) {
    return 'channelName' in metadata;
} /**
 * @public
 */  /**
 * @public
 */  /**
 * @public
 */  // Defaults to PF's ID but can be overridden
 /**
     * @deprecated
     */  // for Open Measurement, best represents the content of the page (excluding personally identifying information)

//# sourceMappingURL=addon-playout-data.js.map